module.exports = __webpack_public_path__ + "img/badge-app-store.729ad9d7.png";